import type { FaireProductEntity } from "../../entity_types/product";

export const p_bfy4dabg8e: FaireProductEntity = {
  token: "p_bfy4dabg8e",
  type: "product",
  name: "Sampler: Whole Bean Coffee",
  brandToken: "b_f358njub53",
  brandName: "Comeback",
  imageUrl: "https://cdn.faire.com/fastly/24f33f402cab28dcd9f67e5b95e7b62918c931bce1d7235665ae1020d5fbd164.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd7394dca987618e36a4740927ce8c0c8a5028472876c245908914ca94d0e3cd.jpeg"
  ],
  priceDollars: 15,
  description: "Try out 3 sample tins of our whole bean coffee offerings to figure out what you like before buying full size options. \n\nTin #1: Costa Rica Natural Tarrazu San Diego\nTin #2: Bali Indonesia Natural\nTin #3: WAHO (Washed Mexico)\n\n",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:47.625Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
